(function () {
  'use strict';

  var COFFRET_HANDLE = 'emballage-cadeau';
  var PROP_COFFRET = 'Coffret';
  var PROP_CONTENU = 'Contenu';
  var PROP_UID = '_coffret_uid';
  var coffretVariantId = null;

  function getTheme() {
    window.theme = window.theme || {};
    return window.theme;
  }

  var theme = getTheme();

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function postJson(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json();
    });
  }

  function isGiftCardItem(item) {
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    var type = ((item.product_type || '') + '').toLowerCase();
    if (title.indexOf('carte') !== -1 && title.indexOf('cadeau') !== -1) return true;
    if (type.indexOf('gift') !== -1) return true;
    return false;
  }

  function isCoffretItem(item, handle) {
    var h = handle || COFFRET_HANDLE;
    if (coffretVariantId && Number(item.variant_id) === Number(coffretVariantId)) return true;
    if (item.handle === h) return true;
    if (item.url && String(item.url).indexOf('/products/' + h) !== -1) return true;
    // Fallback titre (si handle absent du cart.js)
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    if (title.indexOf('emballage') !== -1) return true;
    if (title.indexOf('coffret cadeau') !== -1 && title.indexOf('hiver') === -1) return true;
    // Ligne coffret = a Contenu + Coffret (les produits n’ont que Coffret)
    if (getProp(item, PROP_CONTENU) && getProp(item, PROP_COFFRET) && getProp(item, PROP_UID)) {
      return true;
    }
    return false;
  }

  function getProp(item, key) {
    if (!item.properties) return '';
    var v = item.properties[key];
    return v == null ? '' : String(v);
  }

  function parseCoffretNumber(value) {
    if (!value) return 0;
    var m = String(value).match(/#?\s*(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function formatCoffretLabel(n) {
    return '#' + n;
  }

  /**
   * Répartition Coffret sur UNE ligne (jamais de split qty).
   * Formats :
   *  - "#1"           → toute la qty dans le coffret #1
   *  - "#1 × 1"         → 1 exemplaire dans #1, le reste hors coffret
   *  - "#1 × 1 ; #2 × 1"→ 1 dans #1 et 1 dans #2
   * Retourne un tableau de longueur lineQty (0 = hors coffret).
   */
  function parseCoffretAssignments(value, lineQty) {
    var qty = Math.max(0, parseInt(lineQty, 10) || 0);
    var result = [];
    var i;
    for (i = 0; i < qty; i++) result.push(0);
    if (!value || !String(value).trim() || !qty) return result;

    var raw = String(value).trim();
    // Legacy / tout dans un seul coffret : "#1"
    if (/^#?\s*\d+\s*$/.test(raw)) {
      var all = parseInt(raw.replace('#', ''), 10);
      for (i = 0; i < qty; i++) result[i] = all;
      return result;
    }

    var parts = raw.split(/\s*;\s*/);
    var idx = 0;
    parts.forEach(function (part) {
      if (!part || idx >= qty) return;
      var m = part.match(/#?\s*(\d+)\s*[×xX]\s*(\d+)/); // accepte "×1" et "× 1"
      if (m) {
        var num = parseInt(m[1], 10);
        var q = parseInt(m[2], 10);
        var k;
        for (k = 0; k < q && idx < qty; k++) {
          result[idx++] = num;
        }
        return;
      }
      var m2 = part.match(/#?\s*(\d+)/);
      if (m2 && idx < qty) {
        result[idx++] = parseInt(m2[1], 10);
      }
    });
    return result;
  }

  /** Encode la répartition unitaire → propriété Coffret (sans splitter la ligne). */
  function formatCoffretAssignments(desiredNums) {
    var counts = {};
    var order = [];
    var boxed = 0;
    (desiredNums || []).forEach(function (n) {
      n = parseInt(n, 10) || 0;
      if (n <= 0) return;
      boxed++;
      if (!counts[n]) {
        counts[n] = 0;
        order.push(n);
      }
      counts[n]++;
    });
    if (!boxed) return '';
    // Toute la ligne dans un seul coffret → "#1" (lisible)
    if (boxed === desiredNums.length && order.length === 1) {
      return formatCoffretLabel(order[0]);
    }
    return order
      .map(function (n) {
        return formatCoffretLabel(n) + ' × ' + counts[n];
      })
      .join(' ; ');
  }

  function remapCoffretAssignments(value, fromNum, toNum, lineQty) {
    var arr = parseCoffretAssignments(value, lineQty || 1);
    var changed = false;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === fromNum) {
        arr[i] = toNum;
        changed = true;
      }
    }
    if (!changed) return value;
    return formatCoffretAssignments(arr);
  }

  function cloneBaseProperties(properties) {
    var next = {};
    if (!properties) return next;
    Object.keys(properties).forEach(function (k) {
      if (k === PROP_COFFRET || k === PROP_CONTENU || k === PROP_UID) return;
      if (k.charAt(0) === '_' && k !== PROP_UID) {
        // keep other hidden props
      }
      var val = properties[k];
      if (val == null || val === '') return;
      next[k] = val;
    });
    return next;
  }

  function buildContenu(units) {
    var groups = {};
    units.forEach(function (u) {
      var label = u.title;
      if (u.variantTitle && u.variantTitle !== 'Default Title') {
        label += ' (' + u.variantTitle + ')';
      }
      groups[label] = (groups[label] || 0) + 1;
    });
    return Object.keys(groups)
      .map(function (label) {
        return label + ' × ' + groups[label];
      })
      .join(' ; ');
  }

  function expandUnits(cart, coffretHandle) {
    var units = [];
    (cart.items || []).forEach(function (item) {
      if (isCoffretItem(item, coffretHandle)) return;
      if (isGiftCardItem(item)) return;
      var qty = item.quantity || 0;
      var assigned = parseCoffretAssignments(getProp(item, PROP_COFFRET), qty);
      for (var i = 0; i < qty; i++) {
        units.push({
          unitId: item.key + '::' + i,
          key: item.key,
          variantId: item.variant_id,
          index: i,
          title: item.product_title || item.title,
          variantTitle: item.variant_title || '',
          optionsWithValues: item.options_with_values || [],
          image: item.image,
          coffretNum: assigned[i] || 0,
          properties: item.properties || {}
        });
      }
    });
    return units;
  }

  function maxCoffretNumber(cart, coffretHandle) {
    var max = 0;
    (cart.items || []).forEach(function (item) {
      if (isCoffretItem(item, coffretHandle)) {
        var n2 = parseCoffretNumber(getProp(item, PROP_COFFRET));
        if (n2 > max) max = n2;
        return;
      }
      var assigned = parseCoffretAssignments(getProp(item, PROP_COFFRET), item.quantity || 0);
      assigned.forEach(function (n) {
        if (n > max) max = n;
      });
    });
    return max;
  }

  function itemHasCoffretLabel(item, label) {
    var raw = getProp(item, PROP_COFFRET);
    if (!raw) return false;
    var want = parseCoffretNumber(label);
    if (!want) return false;
    if (isCoffretItem(item)) {
      return parseCoffretNumber(raw) === want;
    }
    var assigned = parseCoffretAssignments(raw, item.quantity || 1);
    return assigned.some(function (n) {
      return n === want;
    });
  }

  /** Index de ligne Shopify (1-based) pour change.js — conserve l’ordre du panier. */
  function lineIndexOf(cart, key) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) return i + 1;
    }
    return 0;
  }

  /** Properties complètes pour un change.js (garde la ligne en place, pas de remove/re-add). */
  function buildChangeProperties(item, overrides) {
    var props = {};
    var src = item.properties || {};
    Object.keys(src).forEach(function (k) {
      if (src[k] == null) return;
      props[k] = src[k];
    });
    Object.keys(overrides || {}).forEach(function (k) {
      props[k] = overrides[k];
    });
    return props;
  }

  /**
   * Renomme toutes les lignes (coffret + produits) de fromNum → toNum.
   * Uniquement via change.js (in-place) pour ne pas bouleverser l’ordre du panier.
   * @param {object} [startCart] — cart déjà chargé (évite un fetch initial)
   */
  function renameCoffretNumber(fromNum, toNum, coffretHandle, startCart) {
    if (fromNum === toNum) {
      return startCart ? Promise.resolve(startCart) : fetchCart();
    }
    var fromLabel = formatCoffretLabel(fromNum);
    var toLabel = formatCoffretLabel(toNum);
    var skipKeys = {};

    function renameOne(cart) {
      var target = (cart.items || []).find(function (item) {
        return itemHasCoffretLabel(item, fromLabel) && !skipKeys[item.key];
      });
      if (!target) return Promise.resolve(cart);

      var overrides = {};
      if (isCoffretItem(target, coffretHandle)) {
        overrides[PROP_COFFRET] = toLabel;
        var contenu = getProp(target, PROP_CONTENU);
        overrides[PROP_CONTENU] = contenu || '';
        // Garder le même uid (un nouvel uid forçait parfois un split / reorder)
        overrides[PROP_UID] = getProp(target, PROP_UID) || coffretUid();
      } else {
        // Produit : remap dans "#1 × 1 ; #2 × 1" sans splitter la ligne
        overrides[PROP_COFFRET] = remapCoffretAssignments(
          getProp(target, PROP_COFFRET),
          fromNum,
          toNum,
          target.quantity || 1
        );
      }
      var props = buildChangeProperties(target, overrides);
      var qty = target.quantity;
      var variantId = target.variant_id;
      var line = lineIndexOf(cart, target.key);
      var prevKey = target.key;

      function applyChange(body) {
        return postJson('/cart/change.js', body).then(function (after) {
          if (!after || !after.items) return fetchCart();
          return after;
        });
      }

      function stillHasOld(after) {
        return (after.items || []).some(function (it) {
          return itemHasCoffretLabel(it, fromLabel) && Number(it.variant_id) === Number(variantId);
        });
      }

      return applyChange({
        id: target.key,
        quantity: qty,
        properties: props
      }).then(function (after) {
        if (!stillHasOld(after)) return renameOne(after);

        // Retry par index de ligne (toujours in-place, jamais remove/re-add)
        if (!line) {
          skipKeys[prevKey] = true;
          return renameOne(after);
        }
        return applyChange({
          line: line,
          quantity: qty,
          properties: props
        }).then(function (after2) {
          if (stillHasOld(after2)) skipKeys[prevKey] = true;
          return renameOne(after2);
        });
      });
    }

    if (startCart && startCart.items) return renameOne(startCart);
    return fetchCart().then(renameOne);
  }

  function listCoffretNumbers(cart, coffretHandle) {
    var nums = [];
    (cart.items || []).forEach(function (item) {
      if (!isCoffretItem(item, coffretHandle)) return;
      var n = parseCoffretNumber(getProp(item, PROP_COFFRET));
      if (n && nums.indexOf(n) === -1) nums.push(n);
    });
    nums.sort(function (a, b) {
      return a - b;
    });
    return nums;
  }

  /**
   * Recompacte les numéros : #2 → #1 après suppression d’un coffret.
   * Compact direct croissant (sans phase 9001) : la cible est toujours libre.
   */
  function compactCoffretNumbers(cart, coffretHandle) {
    var start = cart && cart.items ? Promise.resolve(cart) : fetchCart();
    return start.then(function (fresh) {
      var nums = listCoffretNumbers(fresh, coffretHandle);
      var needsCompact = false;
      nums.forEach(function (n, i) {
        if (n !== i + 1) needsCompact = true;
      });
      if (!needsCompact || !nums.length) return fresh;

      var chain = Promise.resolve(fresh);
      nums.forEach(function (n, i) {
        var finalNum = i + 1;
        if (n === finalNum) return;
        chain = chain.then(function (c) {
          return renameCoffretNumber(n, finalNum, coffretHandle, c);
        });
      });
      return chain;
    });
  }

  function findCoffretLine(cart, coffretNum, coffretHandle) {
    var label = formatCoffretLabel(coffretNum);
    return (cart.items || []).find(function (item) {
      return isCoffretItem(item, coffretHandle) && getProp(item, PROP_COFFRET) === label;
    });
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    fetchCart().then(function (data) {
      if (typeof calculateProgress === 'function') {
        calculateProgress(data.total_price, 12000);
      }
    });
    if (window.jQuery) {
      $('#compteur').load(location.href + ' #compteur');
      $('#compteur2').load(location.href + ' #compteur2');
      $('#compteur-panier').load(location.href + ' #compteur-panier');
      $('#points-fidelite').load(location.href + ' #points-fidelite');
      $('#upsell-cart-desktop').load(location.href + ' #upsell-cart-desktop');
      $('#upsell-cart-mobile').load(location.href + ' #upsell-cart-mobile');
    }
  }

  function coffretUid(existing) {
    if (existing) return String(existing);
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function buildCoffretLineProperties(n, contenu, existingProps) {
    var props = cloneBaseProperties(existingProps || {});
    props[PROP_COFFRET] = formatCoffretLabel(n);
    props[PROP_CONTENU] = contenu || '';
    props[PROP_UID] = coffretUid(existingProps && existingProps[PROP_UID]);
    return props;
  }

  /**
   * Assigne des unités au coffret SANS splitter la ligne panier.
   * Ex. qty 2, 1 cochée → propriété "Coffret : #1 × 1" (une seule ligne).
   * options.skipSync / removeEmpty : inchangés.
   */
  function applyAssignments(cart, selectedUnitIds, coffretNum, coffretHandle, options) {
    options = options || {};
    var selectedSet = {};
    selectedUnitIds.forEach(function (id) {
      selectedSet[id] = true;
    });

    var units = expandUnits(cart, coffretHandle);
    var byKey = {};
    var impacted = {};
    impacted[coffretNum] = true;

    units.forEach(function (u) {
      if (!byKey[u.key]) {
        byKey[u.key] = {
          key: u.key,
          variantId: u.variantId,
          properties: u.properties,
          lineQty: 0,
          desired: []
        };
      }
      var desiredNum = u.coffretNum;
      if (selectedSet[u.unitId]) {
        desiredNum = coffretNum;
      } else if (u.coffretNum === coffretNum) {
        desiredNum = 0;
      }
      if (u.coffretNum > 0 && u.coffretNum !== desiredNum) {
        impacted[u.coffretNum] = true;
      }
      if (desiredNum > 0) impacted[desiredNum] = true;
      byKey[u.key].desired.push(desiredNum);
      byKey[u.key].lineQty++;
    });

    var chain = Promise.resolve();

    Object.keys(byKey).forEach(function (key) {
      var group = byKey[key];
      var wantProp = formatCoffretAssignments(group.desired);
      var currentProp = getProp({ properties: group.properties }, PROP_COFFRET);
      var currentFormatted = formatCoffretAssignments(
        parseCoffretAssignments(currentProp, group.lineQty)
      );
      if (wantProp === currentFormatted || wantProp === currentProp) {
        return;
      }

      chain = chain.then(function () {
        var overrides = {};
        overrides[PROP_COFFRET] = wantProp;
        var props = buildChangeProperties({ properties: group.properties }, overrides);
        return postJson('/cart/change.js', {
          id: key,
          quantity: group.lineQty,
          properties: props
        });
      });
    });

    return chain
      .then(function () {
        return fetchCart();
      })
      .then(function (freshCart) {
        if (options.skipSync) {
          freshCart.__coffretImpacted = impacted;
          return freshCart;
        }
        return syncCoffretContenu(freshCart, impacted, coffretHandle, {
          removeEmpty: !!options.removeEmpty
        }).then(function (c) {
          return mergeIdenticalProductLines(c, coffretHandle);
        });
      });
  }

  function syncCoffretContenu(cart, impactedMap, coffretHandle, options) {
    options = options || {};
    // Ne jamais auto-supprimer une ligne coffret ici : ça faisait disparaître
    // les coffrets juste après l’ajout (course avec les tags produits).
    var removeEmpty = options.removeEmpty === true;

    var nums = Object.keys(impactedMap || {}).map(function (n) {
      return parseInt(n, 10);
    });

    (cart.items || []).forEach(function (item) {
      if (!isCoffretItem(item, coffretHandle)) return;
      var n = parseCoffretNumber(getProp(item, PROP_COFFRET));
      if (n && nums.indexOf(n) === -1) nums.push(n);
    });

    var chain = Promise.resolve(cart);
    nums.forEach(function (n) {
      chain = chain.then(function (c) {
        var unitsNow = expandUnits(c, coffretHandle).filter(function (u) {
          return u.coffretNum === n;
        });
        var line = findCoffretLine(c, n, coffretHandle);
        if (!line) return c;

        if (unitsNow.length === 0) {
          if (removeEmpty) {
            // Coffret vidé (ex. ses produits ont été pris pour un autre) → retirer la ligne
            return postJson('/cart/change.js', { id: line.key, quantity: 0 }).then(fetchCart);
          }
          // Au minimum, vider Contenu pour ne pas afficher des produits fantômes
          if (getProp(line, PROP_CONTENU)) {
            return postJson('/cart/change.js', {
              id: line.key,
              quantity: line.quantity || 1,
              properties: buildCoffretLineProperties(n, '', line.properties)
            }).then(function (after) {
              return after && after.items ? after : fetchCart();
            });
          }
          return c;
        }

        var props = buildCoffretLineProperties(n, buildContenu(unitsNow), line.properties);
        var currentContenu = getProp(line, PROP_CONTENU);
        var currentUid = getProp(line, PROP_UID);
        if (currentContenu === props[PROP_CONTENU] && currentUid && line.quantity === 1) {
          return c;
        }
        return postJson('/cart/change.js', {
          id: line.key,
          quantity: 1,
          properties: props
        }).then(fetchCart);
      });
    });

    return chain;
  }

  /** Si Shopify a fusionné 2 coffrets en qty>1, on re-split en lignes uniques. */
  function splitMergedCoffrets(cart, coffretHandle) {
    var chain = Promise.resolve(cart);
    (cart.items || []).forEach(function (item) {
      if (!isCoffretItem(item, coffretHandle)) return;
      if (item.quantity < 2) return;
      var n = parseCoffretNumber(getProp(item, PROP_COFFRET));
      chain = chain.then(function (c) {
        var live = (c.items || []).find(function (it) {
          return it.key === item.key;
        });
        if (!live || live.quantity < 2) return c;
        var extra = live.quantity - 1;
        return postJson('/cart/change.js', {
          id: live.key,
          quantity: 1,
          properties: buildCoffretLineProperties(
            n || 1,
            getProp(live, PROP_CONTENU),
            live.properties
          )
        })
          .then(function () {
            var addChain = Promise.resolve();
            for (var i = 0; i < extra; i++) {
              addChain = addChain.then(function () {
                return fetchCart().then(function (latest) {
                  var nextNum = maxCoffretNumber(latest, coffretHandle) + 1;
                  return postJson(window.Shopify.routes.root + 'cart/add.js', {
                    items: [
                      {
                        id: live.variant_id,
                        quantity: 1,
                        properties: buildCoffretLineProperties(nextNum, '', {})
                      }
                    ]
                  });
                });
              });
            }
            return addChain;
          })
          .then(fetchCart);
      });
    });
    return chain;
  }

  /** Clé de fusion : même variant + mêmes props (hors Coffret/Contenu/uid vides). */
  function propertiesMergeKey(item) {
    var props = item.properties || {};
    return Object.keys(props)
      .filter(function (k) {
        if (k === PROP_COFFRET || k === PROP_CONTENU || k === PROP_UID) return false;
        var v = props[k];
        return v != null && String(v).trim() !== '';
      })
      .sort()
      .map(function (k) {
        return k + '=' + String(props[k]);
      })
      .join('&');
  }

  /**
   * Refusionne les lignes produit identiques sans coffret
   * (ex. qty 2 splitée pour 1 en coffret → 2× qty1 après suppression du coffret).
   * Garde la première ligne (ordre panier), additionne les qty, retire les autres.
   */
  function mergeIdenticalProductLines(cart, coffretHandle) {
    function mergePass(c) {
      var groups = {};
      (c.items || []).forEach(function (item) {
        if (isCoffretItem(item, coffretHandle)) return;
        if (isGiftCardItem(item)) return;
        if (parseCoffretNumber(getProp(item, PROP_COFFRET))) return;

        var gkey = String(item.variant_id) + '|' + propertiesMergeKey(item);
        if (!groups[gkey]) groups[gkey] = [];
        groups[gkey].push(item);
      });

      var bundle = null;
      Object.keys(groups).some(function (k) {
        if (groups[k].length > 1) {
          bundle = groups[k];
          return true;
        }
        return false;
      });
      if (!bundle) return Promise.resolve(c);

      var keep = bundle[0];
      var totalQty = bundle.reduce(function (sum, it) {
        return sum + (it.quantity || 0);
      }, 0);
      var extras = bundle.slice(1);
      var keepMergeKey = propertiesMergeKey(keep);
      var keepVariant = Number(keep.variant_id);

      var chain = Promise.resolve(c);
      extras.forEach(function (item) {
        chain = chain.then(function (latest) {
          var live = (latest.items || []).find(function (it) {
            return it.key === item.key;
          });
          if (!live) {
            live = (latest.items || []).find(function (it) {
              return (
                Number(it.variant_id) === Number(item.variant_id) &&
                it.key !== keep.key &&
                !parseCoffretNumber(getProp(it, PROP_COFFRET)) &&
                propertiesMergeKey(it) === propertiesMergeKey(item)
              );
            });
          }
          if (!live) return latest;
          return postJson('/cart/change.js', { id: live.key, quantity: 0 }).then(function (after) {
            return after && after.items ? after : fetchCart();
          });
        });
      });

      return chain.then(function (latest) {
        var liveKeep = (latest.items || []).find(function (it) {
          return it.key === keep.key;
        });
        if (!liveKeep) {
          liveKeep = (latest.items || []).find(function (it) {
            return (
              Number(it.variant_id) === keepVariant &&
              !parseCoffretNumber(getProp(it, PROP_COFFRET)) &&
              propertiesMergeKey(it) === keepMergeKey
            );
          });
        }
        if (!liveKeep) return latest;

        var overrides = {};
        overrides[PROP_COFFRET] = '';
        if (getProp(liveKeep, PROP_CONTENU)) overrides[PROP_CONTENU] = '';
        var props = buildChangeProperties(liveKeep, overrides);

        if (liveKeep.quantity === totalQty && !parseCoffretNumber(getProp(liveKeep, PROP_COFFRET))) {
          return mergePass(latest);
        }

        return postJson('/cart/change.js', {
          id: liveKeep.key,
          quantity: totalQty,
          properties: props
        }).then(function (after) {
          var next = after && after.items ? after : null;
          return (next ? Promise.resolve(next) : fetchCart()).then(mergePass);
        });
      });
    }

    if (cart && cart.items) return mergePass(cart);
    return fetchCart().then(mergePass);
  }

  /**
   * Retire la propriété Coffret des produits dont le coffret n’existe plus.
   * Via change.js in-place ('' pour effacer) — pas de remove/re-add (garde l’ordre).
   */
  function reconcileOrphans(cart, coffretHandle) {
    function clearNext(c) {
      var existing = {};
      (c.items || []).forEach(function (item) {
        if (!isCoffretItem(item, coffretHandle)) return;
        var n = parseCoffretNumber(getProp(item, PROP_COFFRET));
        if (n) existing[n] = true;
      });

      var orphan = (c.items || []).find(function (item) {
        if (isCoffretItem(item, coffretHandle)) return false;
        var n = parseCoffretNumber(getProp(item, PROP_COFFRET));
        return !!n && !existing[n];
      });

      if (!orphan) return Promise.resolve(c);

      var overrides = {};
      overrides[PROP_COFFRET] = '';
      if (getProp(orphan, PROP_CONTENU)) overrides[PROP_CONTENU] = '';
      var props = buildChangeProperties(orphan, overrides);
      var line = lineIndexOf(c, orphan.key);

      return postJson('/cart/change.js', {
        id: orphan.key,
        quantity: orphan.quantity,
        properties: props
      })
        .then(function (after) {
          if (after && after.items) {
            var still = (after.items || []).some(function (it) {
              return it.key === orphan.key && parseCoffretNumber(getProp(it, PROP_COFFRET));
            });
            // Même clé peut changer après update properties — check by variant + old label
            if (!still) {
              still = (after.items || []).some(function (it) {
                return (
                  Number(it.variant_id) === Number(orphan.variant_id) &&
                  itemHasCoffretLabel(it, formatCoffretLabel(parseCoffretNumber(getProp(orphan, PROP_COFFRET))))
                );
              });
            }
            if (!still) return after;
          }
          if (!line) return after && after.items ? after : fetchCart();
          return postJson('/cart/change.js', {
            line: line,
            quantity: orphan.quantity,
            properties: props
          });
        })
        .then(function (after) {
          if (after && after.items) return clearNext(after);
          return fetchCart().then(clearNext);
        });
    }

    if (cart && cart.items) return clearNext(cart);
    return fetchCart().then(clearNext);
  }

  /** Après suppression / baisse de qty : Contenu + tags orphelins + renumérotation. */
  function syncAfterCartChange(cart, coffretHandle) {
    return splitMergedCoffrets(cart, coffretHandle)
      .then(function (c) {
        return reconcileOrphans(c, coffretHandle);
      })
      .then(function (c) {
        return mergeIdenticalProductLines(c, coffretHandle);
      })
      .then(function (next) {
        var impacted = {};
        (next.items || []).forEach(function (item) {
          if (!isCoffretItem(item, coffretHandle)) return;
          var n = parseCoffretNumber(getProp(item, PROP_COFFRET));
          if (n) impacted[n] = true;
        });
        // removeEmpty uniquement s’il n’y a plus aucun produit pour ce n°
        // ET que la ligne coffret n’a plus de Contenu utile — géré dans sync sans delete auto.
        if (!Object.keys(impacted).length) {
          return compactCoffretNumbers(next, coffretHandle);
        }
        return syncCoffretContenu(next, impacted, coffretHandle, { removeEmpty: false }).then(
          function (afterSync) {
            return compactCoffretNumbers(afterSync, coffretHandle);
          }
        );
      });
  }

  theme.CoffretDrawer = (function () {
    function CoffretDrawer() {
      this.el = document.getElementById('CoffretDrawer');
      if (!this.el) return;
      this.listEl = this.el.querySelector('[data-coffret-items]');
      this.confirmBtn = this.el.querySelector('[data-coffret-confirm]');
      this.titleEl = this.el.querySelector('#CoffretDrawerTitle');
      this.variantId = parseInt(this.el.getAttribute('data-variant-id'), 10);
      coffretVariantId = this.variantId || coffretVariantId;
      this.coffretHandle = this.el.getAttribute('data-product-handle') || COFFRET_HANDLE;
      this.mode = 'create';
      this.coffretNumber = 0;
      this.lineKey = null;
      this.selected = {};
      this.units = [];
      this.saving = false;
      this._bound = false;
      this.bind();
    }

    CoffretDrawer.prototype.bind = function () {
      if (this._bound || !this.el) return;
      this._bound = true;
      var self = this;

      document.addEventListener('click', function (evt) {
        var openBtn = evt.target.closest('[data-coffret-open]');
        if (openBtn) {
          evt.preventDefault();
          self.open({ mode: 'create' });
          return;
        }
        var editBtn = evt.target.closest('[data-coffret-edit]');
        if (editBtn) {
          evt.preventDefault();
          var num = parseInt(editBtn.getAttribute('data-coffret-number'), 10);
          var key = editBtn.getAttribute('data-line-key');
          self.open({ mode: 'edit', coffretNumber: num, lineKey: key });
          return;
        }
        if (evt.target.closest('[data-coffret-close]') || evt.target.closest('[data-coffret-cancel]')) {
          if (self.el.contains(evt.target) || evt.target.closest('#CoffretDrawer')) {
            evt.preventDefault();
            self.close();
          }
        }
      });

      if (this.confirmBtn) {
        this.confirmBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          self.confirm();
        });
      }

      if (this.listEl) {
        this.listEl.addEventListener('change', function (evt) {
          var input = evt.target.closest('input[data-unit-id]');
          if (!input) return;
          var id = input.getAttribute('data-unit-id');
          if (input.checked) self.selected[id] = true;
          else delete self.selected[id];
          self.updateConfirmState();
        });
      }

      function runCartSync() {
        if (self._reconciling || self.saving) return;
        self._reconciling = true;
        fetchCart()
          .then(function (cart) {
            return syncAfterCartChange(cart, self.coffretHandle).then(function (next) {
              return { before: cart, after: next };
            });
          })
          .then(function (result) {
            self._reconciling = false;
            if (!result || !result.before || !result.after) return;
            if (JSON.stringify(result.before.items) !== JSON.stringify(result.after.items)) {
              document.dispatchEvent(new CustomEvent('cart:build'));
            }
          })
          .catch(function () {
            self._reconciling = false;
          });
      }

      document.addEventListener('cart:updated', runCartSync);

      // Suppress. coffret : même Ajax que les autres lignes (pas de navigation /cart)
      document.addEventListener(
        'click',
        function (evt) {
          var removeBtn = evt.target.closest('.js-cart-remove');
          if (!removeBtn) return;
          var row = removeBtn.closest('.cart__item--coffret, [data-coffret-line]');
          if (!row) return;

          evt.preventDefault();
          evt.stopPropagation();

          var input = row.querySelector('.js-qty__num');
          var key =
            (input && input.getAttribute('data-id')) ||
            row.getAttribute('data-key') ||
            '';
          if (!key) return;

          var qtyWrapper = row.querySelector('.js-qty__wrapper');
          if (qtyWrapper) qtyWrapper.classList.add('is-loading');

          if (theme.cart && typeof theme.cart.changeItem === 'function') {
            theme.cart
              .changeItem(key, 0)
              .then(function (cart) {
                document.dispatchEvent(
                  new CustomEvent('cart:updated', { detail: { cart: cart } })
                );
                document.dispatchEvent(new CustomEvent('cart:build'));
                setTimeout(runCartSync, 400);
              })
              .catch(function () {
                if (qtyWrapper) qtyWrapper.classList.remove('is-loading');
              });
          } else {
            setTimeout(runCartSync, 700);
          }
        },
        true
      );

      // Au chargement : orphelins + compact (#2 seul → #1)
      setTimeout(runCartSync, 900);

      document.addEventListener('keyup', function (evt) {
        if (evt.key === 'Escape' && self.el.classList.contains('is-open')) {
          self.close();
        }
      });
    };

    CoffretDrawer.prototype.open = function (opts) {
      var self = this;
      if (!this.el || !this.variantId) return;
      opts = opts || {};
      this.mode = opts.mode || 'create';
      this.coffretNumber = opts.coffretNumber || 0;
      this.lineKey = opts.lineKey || null;
      this.selected = {};
      this.saving = false;

      if (this.titleEl) {
        this.titleEl.textContent =
          this.mode === 'edit'
            ? 'Modifier le coffret ' + formatCoffretLabel(this.coffretNumber)
            : 'Composer le coffret';
      }

      this.listEl.innerHTML = '<p class="coffret-drawer__empty forma-djr-text fs-14">Chargement…</p>';
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('coffret-drawer-open');

      fetchCart().then(function (cart) {
        self.units = expandUnits(cart, self.coffretHandle);
        if (self.mode === 'edit') {
          self.units.forEach(function (u) {
            if (u.coffretNum === self.coffretNumber) self.selected[u.unitId] = true;
          });
        }
        self.renderList();
        self.updateConfirmState();
      });
    };

    CoffretDrawer.prototype.close = function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('coffret-drawer-open');
    };

    CoffretDrawer.prototype.renderList = function () {
      var self = this;
      if (!this.units.length) {
        this.listEl.innerHTML =
          '<div class="coffret-drawer__empty coffret-drawer__empty--cta forma-djr-text fs-14 text-center">' +
          '<p class="coffret-drawer__empty-text">Ajoutez d’abord des articles au panier, puis revenez composer votre coffret.</p>' +
          '<a href="/collections/all" class="coffret-drawer__empty-cta forma-djr-display fs-14 fw-500 ls-0">Continuer mes achats</a>' +
          '</div>';
        if (this.confirmBtn) {
          this.confirmBtn.disabled = true;
          this.confirmBtn.textContent = 'Sélectionnez au moins 1 article';
        }
        return;
      }

      var html = this.units
        .map(function (u) {
          var checked = !!self.selected[u.unitId];
          var badge = '';
          if (u.coffretNum && u.coffretNum !== self.coffretNumber) {
            badge =
              '<span class="coffret-drawer__badge forma-djr-text fs-14 ls-0">Coffret ' +
              formatCoffretLabel(u.coffretNum) +
              '</span>';
          } else if (u.coffretNum && self.mode === 'edit' && u.coffretNum === self.coffretNumber) {
            badge =
              '<span class="coffret-drawer__badge coffret-drawer__badge--current forma-djr-text fs-14 ls-0">Dans ce coffret</span>';
          }
          var variant = '';
          if (u.optionsWithValues && u.optionsWithValues.length) {
            variant =
              '<div class="coffret-drawer__variant cart__item--variants">' +
              u.optionsWithValues
                .map(function (opt) {
                  return (
                    '<div><span class="product-option">' +
                    escapeHtml(opt.name) +
                    ':</span> ' +
                    escapeHtml(opt.value) +
                    '</div>'
                  );
                })
                .join('') +
              '</div>';
          } else if (u.variantTitle && u.variantTitle !== 'Default Title') {
            variant =
              '<div class="coffret-drawer__variant cart__item--variants">' +
              '<div>' +
              escapeHtml(u.variantTitle) +
              '</div></div>';
          }
          var img = u.image
            ? '<div class="coffret-drawer__img-wrap cart__image"><img src="' +
              escapeHtml(u.image) +
              '" alt="' +
              escapeHtml(u.title) +
              '" loading="lazy" decoding="async"></div>'
            : '<div class="coffret-drawer__img-wrap cart__image"><span class="coffret-drawer__img coffret-drawer__img--placeholder"></span></div>';

          return (
            '<label class="coffret-drawer__item">' +
            '<input type="checkbox" data-unit-id="' +
            escapeHtml(u.unitId) +
            '"' +
            (checked ? ' checked' : '') +
            '>' +
            img +
            '<span class="coffret-drawer__meta">' +
            '<span class="coffret-drawer__name cart-line-title obviously-condensed black fw-600 text-upper fs-21 ls-0">' +
            escapeHtml(u.title) +
            '</span>' +
            variant +
            badge +
            '</span>' +
            '</label>'
          );
        })
        .join('');

      this.listEl.innerHTML = html;
    };

    CoffretDrawer.prototype.updateConfirmState = function () {
      if (!this.confirmBtn) return;
      var count = Object.keys(this.selected).length;
      this.confirmBtn.disabled = count < 1 || this.saving;
      this.confirmBtn.textContent = this.saving
        ? 'Enregistrement…'
        : count < 1
          ? 'Sélectionnez au moins 1 article'
          : 'Valider (' + count + ')';
    };

    CoffretDrawer.prototype.confirm = function () {
      var self = this;
      if (this.saving) return;
      var selectedIds = Object.keys(this.selected);
      if (!selectedIds.length) return;

      this.saving = true;
      this.updateConfirmState();

      fetchCart()
        .then(function (cart) {
          var coffretNum = self.coffretNumber;

          if (self.mode === 'create') {
            coffretNum = maxCoffretNumber(cart, self.coffretHandle) + 1;
            self.coffretNumber = coffretNum;
            var selectedUnits = self.units.filter(function (u) {
              return self.selected[u.unitId];
            });
            if (!selectedUnits.length) {
              throw new Error('Aucun produit sélectionné');
            }
            var contenu = buildContenu(selectedUnits);
            // 1) Ligne coffret d’abord (évite purge orpheline pendant le tagging)
            // 2) Puis assignation produits  3) Sync Contenu
            return postJson(window.Shopify.routes.root + 'cart/add.js', {
              items: [
                {
                  id: self.variantId,
                  quantity: 1,
                  properties: buildCoffretLineProperties(coffretNum, contenu, {})
                }
              ]
            })
              .then(fetchCart)
              .then(function (c) {
                return applyAssignments(c, selectedIds, coffretNum, self.coffretHandle, {
                  skipSync: true
                });
              })
              .then(function (c) {
                var impacted = c.__coffretImpacted || {};
                impacted[coffretNum] = true;
                // removeEmpty: si on a pris tous les produits du #1, supprimer le #1 vide
                return syncCoffretContenu(c, impacted, self.coffretHandle, {
                  removeEmpty: true
                });
              })
              .then(function (c) {
                return mergeIdenticalProductLines(c, self.coffretHandle);
              })
              .then(function (c) {
                return compactCoffretNumbers(c, self.coffretHandle);
              });
          }

          return applyAssignments(cart, selectedIds, coffretNum, self.coffretHandle, {
            removeEmpty: true
          }).then(function (c) {
            return compactCoffretNumbers(c, self.coffretHandle);
          });
        })
        .then(function () {
          self.close();
          refreshCartUi();
          self.saving = false;
          self.updateConfirmState();
        })
        .catch(function (err) {
          console.error('CoffretDrawer error:', err);
          self.saving = false;
          self.updateConfirmState();
          alert('Impossible d’enregistrer le coffret. Réessayez.');
        });
    };

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    var instance = null;

    function getInstance() {
      if (!instance) instance = new CoffretDrawer();
      return instance;
    }

    return {
      init: getInstance,
      open: function (opts) {
        getInstance().open(opts);
      },
      close: function () {
        if (instance) instance.close();
      }
    };
  })();

  // Compat ancienne API
  window.cadeau = function () {
    theme.CoffretDrawer.open({ mode: 'create' });
  };

  document.addEventListener('DOMContentLoaded', function () {
    theme.CoffretDrawer.init();
  });

  // Si le DOM est déjà prêt (script defer en fin de parse)
  if (document.readyState !== 'loading') {
    theme.CoffretDrawer.init();
  }

  // Fiche produit coffret : bloquer l’ajout Ajax natif → même volet que le panier
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target && evt.target.closest && evt.target.closest('.product-single__form--coffret');
      if (!form) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      theme.CoffretDrawer.open({ mode: 'create' });
    },
    true
  );
})();
